import { createSlice } from "@reduxjs/toolkit";
import { EquityBasketSliceInterface } from "interfaces/EquityBasket";

const initialState: EquityBasketSliceInterface = {
  selectedBasket: null,
};

const equityBasketSlice = createSlice({
  name: "equityBasket",
  initialState,
  reducers: {
    SET_SELECTED_BASKET: (state, action) => {
      state.selectedBasket = action.payload;
    },
  },
});

export const { SET_SELECTED_BASKET } = equityBasketSlice.actions;

export default equityBasketSlice.reducer;
